import { connect } from 'react-redux'
import { actions as actionsLaboratory } from 'appRedux/modules/Laboratory'
import { actions as actionsModal } from 'appRedux/modules/Modal'
import { actions as actionsPayment } from 'appRedux/modules/Payment'
import { actions as actionsProduct } from 'appRedux/modules/Product'
import { actions as actionsRenew } from 'appRedux/modules/Renew'
import { actions as actionsUserOrders } from 'appRedux/modules/UserOrders'
import { ProductDetail as component } from './ProductDetail'


const mapStateToProps = (state, ownProps) => ({
	current_product: state.Product.current_product,
	load_error: state.Product.load_error,
	plan_id: state.Payment.plan_id,
	is_mobile: state.Layout.is_mobile,
	authenticated: state.Auth.authenticated,
	result: state.UserOrders.add_single_result,
});
const mapDispatchToProps = (dispatch, ownProps) => ({
	onProductDetailLoad		 : () => dispatch(
		actionsProduct.loadDetailRequest(ownProps.productID)
	),
	onCurrentProductClear	 : () => dispatch(
		actionsProduct.onCurrentProductClear()
	),
	onPayHandler					 : (product, planID) => dispatch
	(actionsPayment.setProduct(product, planID)
),
	onPlanSet							 : (planID) => dispatch(actionsPayment.setPlan(planID)),
	onUserOrdersAddRequest : (list) => dispatch(
		actionsUserOrders.addUserOrderRequest(list)
	),
	onLabListLoadRequest 	 : () => dispatch(actionsLaboratory.loadLabListRequest()),
	onCurrentProductSet 	 : (product) => dispatch(
		actionsProduct.setCurrentProduct(product)
	),
	onRenewReset 					 : () => dispatch(actionsRenew.reset()),
	// modal
	onModalOpen   			   : (id) => dispatch(actionsModal.toggleModal(id, true)),
});
const ProductDetail = connect(mapStateToProps, mapDispatchToProps)(component);


export default ProductDetail
